import { GridSortItem } from "@mui/x-data-grid";
import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import CustomDataGridV2 from "../../../../../components/CustomDataGridV2";
import ToggleSwitch from "../../../../../components/ToggleSwitch";
import ActionMenu from "../../../../../components/app/ActionMenu";
import DiagnosisCodeCatalogDialog from "../../../../../components/app/admin/Library/catalog/DiagnosisCodeCatalogDrawer";
import { diagnosticCodeCatalogInitialValuesType } from "../../../../../constants/initial-schemas";
import { IcdTenCodeCatalogType } from "../../../../../dummy-data/diagnostic-code-catalog";
import useDisclosure from "../../../../../hooks/use-disclosure";
import { useSnackbar } from "../../../../../hooks/useSnackbar";
import { useArchiveCatalogCode } from "../../../../../queries/catalog/use-archive-catalog-code";
import useGetCataLogCode from "../../../../../queries/catalog/use-get-catalog-code";
import { useStatusUpdateCatalogCode } from "../../../../../queries/catalog/use-status-update-catalog-code";
import {
  DEFAULT_PAGE_SIZE,
  DGT_Pagination,
  applyDefaultColumnSettings,
  filterActionCol,
  getSuccessSnackbar,
  isAdmin,
} from "../../../../../utils/utils";
// import { GlobalTableHeightWrapper } from "../../../../../components/GlobalTableHeightWrapper";
import PageLayout from "../../../../../components/PageLayout";
import {
  CATALOG_ACTION,
  CATALOG_ACTIVE_ACTIONS,
  CATALOG_ARCHIVED_ACTIONS,
} from "./catalog-constant";
import { CatalogOutletContext } from "./catalog-types";
import { useCatalogCodeAccess } from "./hooks/use-catalog-code-access";

const CatalogDiagnosisCodeCatalog = () => {
  const { mutateAsync: updateStatus } = useStatusUpdateCatalogCode();
  const { mutateAsync: deleteDiagnosisCode } = useArchiveCatalogCode();
  const { search: searchKey, isArchieved: archived } =
    useOutletContext<CatalogOutletContext>();
  const showSnackbar = useSnackbar();
  const [editDiagnosisValues, setEditDiagnosisValues] =
    useState<diagnosticCodeCatalogInitialValuesType>();
  const [uuid, setUuid] = useState<string>();
  useState<diagnosticCodeCatalogInitialValuesType>();
  const diagnosticCodeEditModalDisclosure = useDisclosure(false);
  const hasMasterData = useCatalogCodeAccess("ICD");
  // const {
  //   opened: openedDeleteModal,
  //   open: openDeleteModal,
  //   close: closeDeleteModal,
  //   deleteId,
  // } = useDeleteDisClosure(false);

  const [pagination, setPagination] = useState<DGT_Pagination>({
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  });
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);

  const {
    data,
    refetch,
    isLoading: isTableLoading,
    isFetching,
  } = useGetCataLogCode({
    gridSorting,
    pagination,
    searchKey,
    type: "ICD",
    active: undefined,
    archive: archived,
  });

  const columns = applyDefaultColumnSettings<IcdTenCodeCatalogType>([
    {
      field: "codeVersion",
      flex: 0.5,
      minWidth: 180,
      headerName: "ICD Code Type",
      disableColumnMenu: true,
    },
    {
      field: "code",
      flex: 0.5,
      minWidth: 180,
      headerName: "ICD Code",
      disableColumnMenu: true,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 2,
      minWidth: 500,
      disableColumnMenu: true,
    },
    {
      field: "active",
      headerName: "Status",
      width: 150,
      disableColumnMenu: true,
      renderCell: ({ row, value }) => (
        <ToggleSwitch
          id={row?.uuid?.toString()}
          checked={value}
          onConfirm={(status, id) =>
            updateStatus({ medicalCodeId: id as string, status }).then(
              (res) => {
                refetch();
                return res;
              }
            )
          }
        />
      ),
    },
    {
      field: "Action",
      width: 90,
      hideSortIcons: true,
      renderCell: ({ row }) => {
        return (
          <ActionMenu
            options={
              row?.archive ? CATALOG_ARCHIVED_ACTIONS : CATALOG_ACTIVE_ACTIONS
            }
            onActionClick={(v) => {
              if (v === CATALOG_ACTION.EDIT) {
                const values = {
                  icd_code_type: undefined,
                  icd_code: row?.code,
                  description: row?.description,
                  codeVersion: row?.codeVersion,
                };
                setUuid(row.uuid?.toString());

                setEditDiagnosisValues(values);
                diagnosticCodeEditModalDisclosure.open();
              } else {
                deleteDiagnosisCode({
                  medicalCodeId: row?.uuid?.toString() as string,
                  archive: v === CATALOG_ACTION.ARCHIVE,
                }).then((res) => {
                  refetch();
                  showSnackbar(getSuccessSnackbar(res));
                  return res;
                });
              }
            }}
          />
        );
      },
    },
  ]);

  return (
    <PageLayout>
      {/* <DeleteModal
        w="380px"
        open={openedDeleteModal}
        onClose={closeDeleteModal}
        id={deleteId}
        onConfirmation={(id) =>
          deleteDiagnosisCode({ medicalCodeId: id as string }).then((res) => {
            refetch();
            return res;
          })
        }
        content={"You want to delete this ICD 10 Code"}
      /> */}

      <DiagnosisCodeCatalogDialog
        dialogTitle="Edit Diagnosis Code"
        disclosureHost={diagnosticCodeEditModalDisclosure}
        preFillValues={editDiagnosisValues}
        uuid={uuid}
      />

      <CustomDataGridV2
        loading={isTableLoading || isFetching}
        searchString={searchKey}
        getRowId={(row) => row.uuid}
        rows={data?.data?.content ?? []}
        columns={filterActionCol(columns, !isAdmin() ? !hasMasterData : false)}
        disableRowSelectionOnClick
        paginationModel={pagination}
        onPaginationModelChange={setPagination}
        onSortModelChange={setGridSorting}
        rowCount={data?.data?.page?.totalElements ?? 10}
      />
    </PageLayout>
  );
};

export default CatalogDiagnosisCodeCatalog;
